if (window.location.href.includes('collections')) {

    document.querySelectorAll('.js-products-listing__side-filters-categories').forEach(el => {
        if (el.dataset.category === el.dataset.collection) {
            el.classList.add('active');
        } else {
            let subcategory = el.querySelectorAll('.js-subcategory');
            subcategory.forEach(sub => {
                if (el.dataset.collection == sub.dataset.subcategory) {
                    el.classList.add('active');                }
            });
        }
    })

    // CLEAR ALL BUTTON
    // if (window.location.search || !window.location.pathname.includes('/collections/all')) {
    //     document.querySelector('.js-clear-all').classList.remove('hidden');
    // } else {
    //     document.querySelector('.js-clear-all').classList.add('hidden');
    // }

    document.querySelector('.js-apply-filters').addEventListener('click', function() {
        let sizes = document.querySelectorAll('.js-products-listing__side-filters-sizes-box.active');
        let colors = document.querySelectorAll('.js-products-listing__side-filters-colors-box.active');
        let lengthCups = document.querySelectorAll('.js-products-listing__side-filters-lengthcup-box.active')
        let vendors = document.querySelectorAll('.js-products-listing__side-filters-brands-box.active');
        let tags = document.querySelectorAll('.js-products-listing__side-filters-tags-box.active');
        let sizeValues = [];
        let colorValues = [];
        let vendorValues = [];
        let lengthCupsValues = [];
        let tagsValues = [];
        let urlParams = new URLSearchParams(window.location.search);

        // Reset filter values
        urlParams.delete('filter.v.option.size');
        urlParams.delete('filter.v.option.color');
        urlParams.delete('filter.v.option.lengthcup');
        urlParams.delete('filter.p.m.custom.vendors');
        urlParams.delete('filter.p.m.custom.clearance_filter');

        // Get size values
        sizes.forEach(size => {
            if (!urlParams.getAll('filter.v.option.size').includes(size.innerHTML)) {
                urlParams.append('filter.v.option.size', size.innerHTML)
                sizeValues.push(size.innerHTML);
            }
        });

        // Get color values
        colors.forEach(color => {
            if (!urlParams.getAll('filter.v.option.color').includes(color.dataset.colorName)) {
                urlParams.append('filter.v.option.color', color.dataset.colorName);
                colorValues.push(color.dataset.colorName);
            }
        });

        lengthCups.forEach(lengthCup => {
            if (!urlParams.getAll('filter.v.option.lengthcup').includes(lengthCups.innerHTML)) {
                urlParams.append('filter.v.option.lengthcup', lengthCup.innerHTML)
                lengthCupsValues.push(lengthCup.innerHTML);
            }
        });

        vendors.forEach(vendor => {
            if (!urlParams.getAll('filter.p.m.custom.vendors').includes('gid://shopify/Metaobject/' + vendor.dataset.vendorGid)) {
                urlParams.append('filter.p.m.custom.vendors', 'gid://shopify/Metaobject/' + vendor.dataset.vendorGid)
                vendorValues.push(vendor.dataset.vendorGid);
            }
        });

        tags.forEach(tag => {
            const tagText = tag.dataset.tag;
            if (!urlParams.getAll('filter.p.m.custom.clearance_filter').includes(tagText)) {
                urlParams.append('filter.p.m.custom.clearance_filter', tagText);
                tagsValues.push(tagText);
            }
        });

        window.location.search = urlParams;
    });

    let filtersApplied = new URLSearchParams(window.location.search);
    filtersApplied.forEach((filter, key) => {
        if (key.includes('size')) {
            let sizeElement = document.querySelector(`.js-products-listing__side-filters-sizes-box[data-size="${filter}"]`);
            sizeElement.classList.add('active');
            let content = {
                size: filter,
                key: key
            }
            insertPill(content, 'size');
        } else if (key.includes('vendors')) {
            let vendorID = filter.replace(/^\D+/g, '');
            let vendorElement = document.querySelector(`.js-products-listing__side-filters-brands-box[data-vendor-gid="${vendorID}"]`);
            vendorElement.classList.add('active');
            let content = {
                vendorImage: vendorElement.querySelector('img'),
                key: key,
                filter: filter
            }
            insertPill(content, 'vendor')
        } else if (key.includes('lengthcup')) {
            let lengthCupElement = document.querySelector(`.js-products-listing__side-filters-lengthcup-box[data-size='${filter}']`);
            lengthCupElement.classList.add('active');
            let content = {
                lengthcup: filter,
                key: key
            }
            insertPill(content, 'lengthcup');
        } else if (key.includes('color')) {
            let colorElement = document.querySelector(`.js-products-listing__side-filters-colors-box[data-color-name="${filter}"]`);
            colorElement.classList.add('active');
            let color_hex;
            let color_type;
            if (colorElement.style.backgroundColor && !colorElement.dataset.colors && !colorElement.dataset.multicolor) {
                color_type = 'hex';
                color_hex = colorElement.style.backgroundColor;
            } else if (colorElement.style.background && colorElement.dataset.colors) {
                color_type = 'gradient';
                color_hex = colorElement.dataset.colors;
            } else if (colorElement.dataset.multicolor) {
                color_type = 'multicolor';
                color_hex = '';
            }

            let content = {
                color_type: color_type,
                color_name: filter,
                color_hex: color_hex,
                key: key
            };
            insertPill(content, 'color');
        } else if (key.includes('clearance_filter')) {
            let tagElement = document.querySelector(`.js-products-listing__side-filters-tags-box[data-tag="${filter}"]`);
            let collectionTitle = tagElement.querySelector('span').innerHTML;
            tagElement.classList.add('active');

            let content = {
                tag: filter,
                collectionTitle: collectionTitle,
                key: key
            }
            insertPill(content, 'clearance_filter');
        }
    })

    function insertPill(content, type) {
        if (type === 'color') {
            let spanEl  = ``;
            switch (content.color_type) {
                case 'hex':
                    spanEl = `<div class="products-listing__products-pill-color" style="background-color: ${content.color_hex};"></div>`;
                    break;

                case 'gradient':
                    spanEl = `<div class="products-listing__products-pill-color" style="background: linear-gradient(${content.color_hex});"></div>`;
                    break;

                case 'multicolor':
                    spanEl = `<div class="products-listing__products-pill-color" style="background: linear-gradient(#ff0000, transparent), linear-gradient(to top left, #00ff00, transparent), linear-gradient(to top right, #0000ff, transparent); background-blend-mode: screen;"></div>`;
                    break;
            }
            let html = `
            <div class="products-listing__products-pill products-listing__products-pill--alt">
                ${spanEl}
                <div class="products-listing__products-pill-text">${content.color_name}</div>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.color_name}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'size') {
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text">Size:<span>${content.size}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.size}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'lengthcup') {
            let label = content.lengthcup.includes('"') ? 'Length' : 'Cup';
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text">${label}:<span>${content.lengthcup}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value='${content.lengthcup}'></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'vendor') {
            let html = `
            <div class="products-listing__products-pill">
                <div class="products-listing__products-pill-logo-img">
                <img src="${content.vendorImage.src}" alt="${content.vendorImage.alt}">
                </div>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.filter}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'clearance_filter') {
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text"><span>${content.collectionTitle}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.tag}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
    }
    document.querySelectorAll('.js-close-icon').forEach(el => {
        el.addEventListener('click', function(e) {
            let urlParams = new URLSearchParams(window.location.search);

            urlParams.delete(e.target.dataset.filterKey, e.target.dataset.filterValue)

            window.location.search = urlParams;
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
  const titles = document.querySelectorAll(".products-listing__side-filters-sizes-title");

  titles.forEach(function(title) {
    const container = title.nextElementSibling; // assumes container is right after the title

    title.addEventListener("click", function() {
      container.classList.toggle("is-open");
      title.classList.toggle("is-open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const title = document.querySelector(".products-listing__side-filters-colors-title");
  const container = document.querySelector(".products-listing__side-filters-colors-container");

  title.addEventListener("click", function() {
    container.classList.toggle("is-open");
    title.classList.toggle("is-open");
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const title = document.querySelector(".products-listing__side-filters-brands-title");
  const container = document.querySelector(".products-listing__side-filters-brands-container");

  title.addEventListener("click", function() {
    container.classList.toggle("is-open");
    title.classList.toggle("is-open");
  });
});